import React, {useEffect, useRef, useState} from 'react';
import {Dispatch, bindActionCreators} from 'redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {RootState} from '../../reducers';
import * as actions from '../../actions/generalActions';
import * as clientActions from '../../actions/client';
import {resetClient} from "../../actions/client";
import * as generalActions from '../../actions/generalActions';
import * as projectDeletionActions from '../../actions/projectDeletions';
import { formatCascadeCountsLine } from './projectDeletionHelpers';
import {Button, EButtonType} from '../../components/Button';
import {toast} from 'react-toastify';
import "./Contact.scss";
import './createContactForm.scss';
import moment from 'moment';
import {useHistory, withRouter} from 'react-router';
import * as Yup from "yup";
import * as validationConfigs from '../../utils/validationConfigs';
import {User} from '../../types/user.type';
import Spinner from '../../components/Spinner';
import {apiCaller, axiosCaller} from '../../utils/apiCaller';
import {ArticleInfomation} from '../../types/ArticleInformation.type';
import {SelectOption} from '../../types/selectOption.type';
import MikaTextInput from "../../components/Input/MikaTextInput/MikaTextInput";
import FormikFormWrapper from "../../components/FormikFormWrapper/FormikFormWrapper";
import FontAwesome from 'react-fontawesome'
import {useParams} from "react-router-dom";
import {ParameterTypes} from '../../types/parameter.type';
import {checkIfUserIsAuthorized} from "../Admin/globalFunctions";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import MikaFileInput from "../../components/Input/MikaFileInput/MikaFileInput";
import MikaFileManager from "../../components/MikaFileManager/MikaFileManager";
import PICFile from "../../assets/icons/pic.svg";
import {Project} from "../../types/Project.type";

interface Props {
    intl: any;
    setLoading: boolean;

    nextStep(): void;

    actions: any;
    clientActions: any;
    client: any;
    loading: boolean;
    articles: ArticleInfomation[];
    validationMessageConfig: any;
    letter: string;
    app: any;
    user: any;
    measureUsers: User[];
    generalActions: any;
    allClients: SelectOption[];
    countries: any[];
    citiesFields: any[];
    permissions: any;
    companyProfile?: any;
    history: any;
    buttonLoader: boolean
    projectDeletionActions: any;
}

const CreateContactForm = (props: Props) => {
    const fm = (id: string, defaultMessage: string) => props.intl.formatMessage({ id, defaultMessage });
    const fmWithValues = (id: string, defaultMessage: string, values: Record<string, any>) =>
        props.intl.formatMessage({ id, defaultMessage }, values);

    const {clientId} = useParams<ParameterTypes>();
    const [dateRange, setDateRange] = useState([new Date(Date.now() - 24 * 24 * 60 * 60 * 1000), new Date()]);
    const [startDate, endDate] = dateRange;
    const [createAt, setCreatedAt] = useState()
    const [searchedClient, setSearchedClient] = useState<string>()
    const [clients, setClients] = useState<SelectOption[]>([])
    const [countries, setCountries] = useState<SelectOption[]>([])
    const [country, setCountry] = useState<SelectOption>({} as SelectOption)
    const [cities, setCities] = useState<SelectOption[]>([])
    const [city, setCity] = useState<SelectOption>({} as SelectOption)
    const [filteredClients, setFilteredClients] = useState<SelectOption[]>([])
    // KuBIT client-form alignment (piece 2): entity-type + phone-prefix dropdowns,
    // populated from the synced KuBIT mirrors. Only shown when kubitEnabled.
    const kubitEnabled = !!props.companyProfile?.kubitEnabled
    const [entityTypes, setEntityTypes] = useState<SelectOption[]>([])
    const [entityTypeId, setEntityTypeId] = useState<number | null>(null)
    const [phonePrefixes, setPhonePrefixes] = useState<any[]>([])
    const [phonePrefixId, setPhonePrefixId] = useState<number | null>(null)
    const [showRequiredMessage, setShowRequiredMessage] = useState<boolean>(false)
    const [projectDetails, setProjectDetails] = useState<Project[]>([{} as Project])
    const [expandedProject, setExpandedProject] = useState<number>(-1)
    // message accepts ReactNode so callers can compose rich content (e.g. the cascade-count list
    // shown when deleting a project) — strings still work, they're valid ReactNodes.
    const [confirmAction, setConfirmAction] = useState<{message: React.ReactNode, onConfirm: () => void} | null>(null)
    const [deletePreviewLoading, setDeletePreviewLoading] = useState(false)
    const [isCompany, setIsCompany] = useState<boolean>(false)
    const [selectedFiles, setSelectedFiles] = useState<{[projectIndex: number]: number[]}>({})
    const [filesLoading, setFilesLoading] = useState(false)
    // Guards the whole save operation against double-submission. The save is multi-step
    // (client + projects), so the Redux `buttonLoader` flag toggles mid-flow and briefly
    // re-enables the button; this local flag stays true until the entire flow settles.
    // `isSubmitting` drives the button UI; `isSubmittingRef` is the actual re-entry guard —
    // a ref is read/written synchronously so it can't be stale across the microtask that
    // Formik's async validation introduces before onSubmit (state could, in a click-burst).
    const [isSubmitting, setIsSubmitting] = useState(false)
    const isSubmittingRef = useRef(false)
    // The phone prefix as loaded on edit (null in create). The submit-time length check
    // fires when the phone OR the prefix changed: switching the prefix makes the same
    // number newly valid/invalid, so it must re-validate even if the number is untouched.
    const initialPhonePrefixIdRef = useRef<number | null>(null)
    const [initialValues, setInitialValues] = useState({
        nameAndSurname: '',
        lastName: '',
        phoneNr: '',
        secondPhoneNr: '',
        email: '',
        comment: '',
        businessNr: '',
        address: '',
        secondAddress: '',
        bankAccountNr: '',
        bankName: '',
        contactPerson: '',
        parentName: '',
        companyName: '',
        file: null
    })
    const fromDate = moment().subtract(24, 'd').format('DD.MM.YYYY') || "24.06.2021"
    const toDate = moment(endDate).format("DD.MM.YYYY")
    const letter_ = props.letter || "A";

    const history = useHistory();

    useEffect(() => {
        props.generalActions.fetchArticles();
        props.actions.getAllMeasureUsers();
        props.actions.fetchCountries();
        axiosCaller('GET', `clients/all-clients-with-id-and-firstname-and-lastname`).then(res => {
            setClients(res.data.data)
        })
    }, []);

    // KuBIT lookups for the contact form (entity types + phone prefixes). Only when
    // KuBIT is enabled (empty for non-KuBIT companies). Defaults the prefix to
    // Kosovo (+383) in create mode; leaves it as-selected on edit.
    useEffect(() => {
        if (!kubitEnabled) return
        axiosCaller('GET', 'kubit/entity-types')
            .then((res: any) => setEntityTypes(res?.data?.data ?? res?.data ?? []))
            .catch(() => undefined)
        axiosCaller('GET', 'kubit/phone-prefixes')
            .then((res: any) => {
                const prefixes = res?.data?.data ?? res?.data ?? []
                setPhonePrefixes(prefixes)
                if (!clientId) {
                    const kosovo = prefixes.find((p: any) => p.prefix === '+383')
                    if (kosovo) setPhonePrefixId((prev) => prev ?? kosovo.value)
                }
            })
            .catch(() => undefined)
    }, [kubitEnabled]);

    useEffect(() => {
        if (Object.keys(props.permissions)?.length !== 0 && !checkIfUserIsAuthorized(props.permissions, props.permissions.fullPrivileges, props.permissions.contact)) {
            toast.error(fm('contact.toast.notAuthenticatedToModify', "You are not authorized to modify this module's data."))
            history.push('/dashboard/contact')
        }
    }, [props.permissions])

    useEffect(() => {
        // Immediately clear projects when switching to create mode
        // to prevent stale projects from a previous client being used
        if (!clientId) {
            props.clientActions.saveClientProjects([])
            setExpandedProject(0) // expand first project in create mode
        } else {
            setExpandedProject(-1) // all collapsed in edit mode
        }
        getModuleData()
    }, [clientId])

    // Sync projects from Redux
    useEffect(() => {
        if (props.client?.clientProjects && props.client?.clientProjects?.length !== 0) {
            setProjectDetails([...props.client.clientProjects].sort((a, b) => (b.id || 0) - (a.id || 0)))
        } else if (!clientId) {
            // Create mode: start with one empty project
            setProjectDetails([{} as Project])
        } else {
            setProjectDetails([])
        }
    }, [props.client?.clientProjects])

    useEffect(() => {
        if (!searchedClient?.trim()) {
            setFilteredClients([])
            return
        }
        const search = searchedClient.toLowerCase()
        const filtered = clients.filter(val =>
            val.firstNameAndLastName?.toLowerCase().includes(search)
        )
        setFilteredClients(filtered)
    }, [searchedClient])

    useEffect(() => {
        let tempCountriesArray = []
        props.countries.forEach((countryObject, index) => {
            tempCountriesArray.push({
                label: countryObject.country,
                value: index
            })
        })
        setCountries(tempCountriesArray)
    }, [props.countries])

    useEffect(() => {
        if (country.label) {
            props.actions.fetchCities(country.label)
        }
        if (props.client?.client?.country == country?.label) {
            if (props.client?.client?.city) {
                setCity({
                    label: props.client?.client?.city,
                    value: undefined
                })
                return
            }
        }
        setCity({
            label: '',
            value: undefined
        })
    }, [country])

    useEffect(() => {
        let tempCitiesArray = []
        props.citiesFields.forEach((cityObject, index) => {
            tempCitiesArray.push({
                label: cityObject.city,
                value: index
            })
        })
        setCities(tempCitiesArray)

    }, [props.citiesFields])

    function getModuleData() {
        if (clientId !== undefined) {
            props.clientActions.getClientProjects(clientId)
            props.clientActions.fetchClient(clientId, 1).then((res) => {
                setInitialValues({
                    nameAndSurname: res.data?.firstnameAndLastname ? res.data?.firstnameAndLastname : '',
                    lastName: res.data?.lastName ? res.data?.lastName : '',
                    phoneNr: res.data?.phoneNumber ? res.data?.phoneNumber : '',
                    secondPhoneNr: res.data?.secondPhoneNumber ? res.data?.secondPhoneNumber : '',
                    email: res.data?.email ? res.data?.email : '',
                    comment: res.data?.commentAndDetails ? res.data?.commentAndDetails : '',
                    businessNr: res.data?.businessNumber ? res.data?.businessNumber : '',
                    address: res.data?.address ? res.data?.address : '',
                    secondAddress: res.data?.secondAddress ? res.data?.secondAddress : '',
                    bankAccountNr: res.data?.bankAccountNumber ? res.data?.bankAccountNumber : '',
                    bankName: res.data?.bankAccount ? res.data?.bankAccount : '',
                    contactPerson: res.data?.contactPerson ? res.data?.contactPerson : '',
                    parentName: res.data?.parentName ? res.data?.parentName : '',
                    companyName: res.data?.companyName ? res.data?.companyName : '',
                    file: {
                        employerId: "",
                        fileName: "",
                        file: null
                    }
                })

                setCountry({
                    label: res.data?.country,
                    value: undefined
                })
                // KuBIT: re-select the client's stored entity type + phone prefix.
                setEntityTypeId(res.data?.entityTypeId ?? null)
                setPhonePrefixId(res.data?.phonePrefixId ?? null)
                initialPhonePrefixIdRef.current = res.data?.phonePrefixId ?? null
                setCreatedAt(res.data?.createdAt)
                if (res.data?.companyName || res.data?.businessNumber) {
                    setIsCompany(true)
                }
            })
        } else {
            resetFields()
        }
    }

    function validationScheme() {
        return Yup.object().shape({
            nameAndSurname: validationConfigs.NAME_SURNAME_VALIDATION,
            lastName: validationConfigs.LAST_NAME_VALIDATION,
            // KuBIT: phoneNr holds only the local number; its exact length is checked
            // per-prefix at submit, so relax the fixed min(9) (which false-rejects e.g.
            // Kosovo's 8-digit local number). Non-KuBIT keeps the strict validation.
            phoneNr: kubitEnabled ? validationConfigs.KUBIT_LOCAL_PHONE_VALIDATION : validationConfigs.PHONE_VALIDATION,
            // Email is validated manually in saveClient (only when set/changed), NOT here:
            // a schema rule would block ALL edits to a legacy client that has a malformed
            // email stored, even when the user is only touching the phone.
            // email: validationConfigs.EMAIL_VALIDATION,
            // secondPhoneNr: validationConfigs.SECOND_PHONE_VALIDATION,
            // businessNr: validationConfigs.BUSINESS_NR_VALIDATION,
            // address: validationConfigs.ADDRESS_VALIDATION,
            // bankAccountNr: validationConfigs.BANK_ACCOUNT_NR_VALIDATION,
            // comment: validationConfigs.COMMENT_VALIDATION,
            // bankName: validationConfigs.BANK_NAME_VALIDATION,
            // contactPerson: validationConfigs.CONTACT_PERSON_VALIDATION,
            // order: validationConfigs.ORDER_VALIDATION,
        });
    }

    function resetFields() {
        props.clientActions.saveClientProjects([])
        props.clientActions.resetClient({ id: undefined })
        setInitialValues({
            nameAndSurname: '',
            lastName: '',
            phoneNr: '',
            secondPhoneNr: '',
            email: '',
            comment: '',
            businessNr: '',
            address: '',
            secondAddress: '',
            bankAccountNr: '',
            bankName: '',
            contactPerson: '',
            parentName: '',
            companyName: '',
            file: null
        })
        setCountry({label: 'Kosovo', value: 76})
        // KuBIT: clear entity type; default the phone prefix back to Kosovo (+383).
        setEntityTypeId(null)
        setPhonePrefixId(phonePrefixes.find((p: any) => p.prefix === '+383')?.value ?? null)
        initialPhonePrefixIdRef.current = null
        setCreatedAt(null)
        history.push('/dashboard/contact/create')
    }

    function changeProjectDetails(name, value, projectIndex) {
        let isValid = true
        if (name === 'measureDate') {
            let dateValue = new Date(value).getTime()
            let todayTime = new Date().getTime()
            if (dateValue < (todayTime - 86400000)) {
                toast.error(fm('contact.toast.dateCannotBePast', 'The date cannot be in the past.'))
                return
            }
        } else if (name === 'projectLocation') {
            ;[...value]?.forEach((letter) => {
                if (/^[a-zA-Z]+$/.test(letter)) { isValid = false }
                else { isValid = true }
            })
        }
        if (isValid) {
            let tempArray = [...projectDetails]
            tempArray[projectIndex] = { ...tempArray[projectIndex], [name]: value }
            setProjectDetails(tempArray)
        }
    }

    function getCurrentPosition(projectIndex: number) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const currentLocation = `${position.coords.latitude},${position.coords.longitude}`
                let tempArray = [...projectDetails]
                tempArray[projectIndex] = { ...tempArray[projectIndex], projectLocation: currentLocation }
                setProjectDetails(tempArray)
            },
            (err) => console.warn(`ERROR(${err.code}): ${err.message}`),
            { enableHighAccuracy: true, timeout: 5000, maximumAge: 60000 }
        )
    }

    function removeProjectFile(fileId) {
        setConfirmAction({
            message: fm('contact.project.confirmDeleteFile', 'Are you sure you want to delete this file?'),
            onConfirm: async () => {
                setConfirmAction(null)
                setFilesLoading(true)
                try {
                    await props.generalActions?.removeFile('project', fileId)
                    await getModuleData()
                } finally {
                    setFilesLoading(false)
                }
            }
        })
    }

    function toggleFileSelection(projectIndex: number, fileId: number) {
        setSelectedFiles(prev => {
            const current = prev[projectIndex] || []
            const updated = current.includes(fileId)
                ? current.filter(id => id !== fileId)
                : [...current, fileId]
            return { ...prev, [projectIndex]: updated }
        })
    }

    function toggleAllFiles(projectIndex: number, allFileIds: number[]) {
        setSelectedFiles(prev => {
            const current = prev[projectIndex] || []
            const allSelected = allFileIds.length > 0 && allFileIds.every(id => current.includes(id))
            return { ...prev, [projectIndex]: allSelected ? [] : allFileIds }
        })
    }

    function deleteSelectedFiles(projectIndex: number) {
        const fileIds = selectedFiles[projectIndex] || []
        if (fileIds.length === 0) return
        setConfirmAction({
            message: fmWithValues(
                'contact.project.confirmDeleteBulkFiles',
                'Are you sure you want to delete {count, plural, one {# file} other {# files}}?',
                { count: fileIds.length }
            ),
            onConfirm: async () => {
                for (const fileId of fileIds) {
                    await props.generalActions?.removeFile('project', fileId)
                }
                setSelectedFiles(prev => ({ ...prev, [projectIndex]: [] }))
                setConfirmAction(null)
                getModuleData()
            }
        })
    }

    function addNewProject() {
        setProjectDetails(prev => {
            const newArray = [{} as Project, ...prev]
            setExpandedProject(0)
            return newArray
        })
    }

    function deleteProject(projectId, projectIndex) {
        // Unsaved project (no id) — drop it locally without a server call or modal.
        if (!projectId) {
            setProjectDetails(prev => prev.filter((_, i) => i !== projectIndex))
            setExpandedProject(-1)
            return
        }

        // Fetch the cascade preview so the confirmation can show what will be deleted.
        setDeletePreviewLoading(true)
        props.projectDeletionActions.getProjectDeletionPreview(projectId).then((res: any) => {
            // axiosCaller returns AxiosResponse — body at res.data, controller wraps under .data,
            // so the preview payload is at res.data.data.
            const counts = res?.data?.data?.affected_counts || null
            const cascadeNode = formatCascadeCountsLine(counts)
            const messageNode = cascadeNode ? (
                <FormattedMessage
                    id="contact.project.confirmDelete.messageWithCascade"
                    defaultMessage="This will delete the project along with {items}. The project can be restored from Recently Deleted."
                    values={{ items: cascadeNode }}
                />
            ) : (
                <FormattedMessage
                    id="contact.project.confirmDelete.message"
                    defaultMessage="Are you sure you want to delete this project? It can be restored from Recently Deleted."
                />
            )
            setConfirmAction({
                message: messageNode,
                onConfirm: () => {
                    // axiosCaller returns the full AxiosResponse, so the body shape from
                    // ProjectController::deleteProject lives at res.data:
                    //   res.data.data === true          → deleted; show success toast + refresh
                    //   res.data.reason === 'products_in_production' → blocked by guard
                    //   res.data.reason === 'unauthorized'           → no perm
                    //   anything else                                 → generic failure
                    // Crucially, we no longer optimistically toast success — only when
                    // the backend actually confirms.
                    props.clientActions.deleteProject(projectId).then((res: any) => {
                        const body = res?.data
                        if (body?.data === true) {
                            getModuleData()
                            toast.success(fm('contact.project.deleteSuccess', 'Project deleted. Recoverable from Recently Deleted.'))
                            setProjectDetails(prev => prev.filter((_, i) => i !== projectIndex))
                            setExpandedProject(-1)
                        } else if (body?.reason === 'products_in_production') {
                            const count = Number(body?.blocking_product_count) || 0
                            const template = fm('contact.project.deleteFailed.productsInProduction', 'Nuk mund të fshihet ky projekt — {count} produkte kanë filluar prodhimin. Mbaroni ose anuloni produktet në prodhim para se ta fshini projektin.')
                            toast.error(template.replace('{count}', String(count)))
                        } else if (body?.reason === 'unauthorized') {
                            toast.error(fm('contact.project.deleteFailed.unauthorized', 'Nuk keni leje për ta fshirë këtë projekt.'))
                        } else {
                            toast.error(fm('contact.project.deleteFailed.generic', 'Ky projekt nuk mund të fshihet.'))
                        }
                    })
                    setConfirmAction(null)
                }
            })
        }).finally(() => setDeletePreviewLoading(false))
    }

    const saveClient = async (values) => {
        // Ignore extra clicks while a save is already in flight — prevents duplicate
        // clients/projects from an impatient double-click before the request resolves.
        if (isSubmittingRef.current) return

        // Validate projects
        let projectsValid = true
        projectDetails.forEach(p => {
            if (!p.projectName) { projectsValid = false }
            if (!p.id && !p.shipmentDestinationId) { projectsValid = false }
        })
        if (!projectsValid) {
            setShowRequiredMessage(true)
            return
        }

        // Sync projects to Redux
        props.clientActions.saveClientProjects(projectDetails)

        if (projectDetails.length === 0) {
            toast.error(fm('contact.toast.createProjectRequired', 'Please add a project for this client.'))
            return;
        }
        if (!city.label) {
            setShowRequiredMessage(true)
            return
        }
        if (!country.label) {
            setShowRequiredMessage(true)
            return
        }
        // KuBIT: entity type is required, and the local phone number must match the
        // selected prefix's expected digit count (from the live sync-phoneprefixes data).
        if (kubitEnabled) {
            if (!entityTypeId) {
                setShowRequiredMessage(true)
                return
            }
            // KuBIT requires a business number for business subjects (1=me TVSH, 2=pa TVSH,
            // 4=i Jashtem). Block here so the user isn't hit with a KuBIT 400 later (e.g.
            // server.BusinessNumberForVATSubjectMustStartWith8Or6). Person Fizik (8) may omit it.
            if ([1, 2, 4].includes(entityTypeId) && !(values.businessNr || '').trim()) {
                setShowRequiredMessage(true)
                toast.error(fm('contact.form.businessNrRequired', 'Business number is required for this subject type.'))
                return
            }
            const selectedPrefix = phonePrefixes.find((p: any) => p.value === phonePrefixId)
            // Enforce the exact local length only when the phone OR the prefix changed —
            // a prefix switch re-validates the same number (length is prefix-relative).
            // An untouched (phone, prefix) pairing is left alone so an unrelated edit
            // (e.g. address-only) of a legacy/reconciled client isn't bricked. Mirrors
            // the email guard below (validate new input, not untouched legacy data).
            const phoneOrPrefixChanged = values.phoneNr !== initialValues.phoneNr || phonePrefixId !== initialPhonePrefixIdRef.current
            if (selectedPrefix?.numberLength && phoneOrPrefixChanged) {
                const digits = (values.phoneNr || '').replace(/\D/g, '')
                if (digits.length !== selectedPrefix.numberLength) {
                    toast.error(fmWithValues('contact.form.phoneLengthInvalid', 'Phone number must be {n} digits for {prefix}.', { n: selectedPrefix.numberLength, prefix: selectedPrefix.prefix }))
                    return
                }
            }
        }
        // Email: block a malformed address, but only when the user actually set or
        // changed it — never retroactively brick editing a legacy client whose stored
        // email is bad (validate new input, not untouched old data). Empty stays allowed.
        if (values.email && values.email !== initialValues.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
            toast.error(fm('contact.form.emailInvalid', 'Please enter a valid email address.'))
            return
        }
        let formData = new FormData();

        if (values.nameAndSurname) {
            formData.append("firstNameAndLastName", values.nameAndSurname.charAt(0).toUpperCase() + values.nameAndSurname.slice(1));
        }
        if (values.lastName) {
            formData.append("lastName", values.lastName);
        }
        if (values.address) {
            formData.append("address", values.address);
        }
        if (values.secondAddress) {
            formData.append("secondAddress", values.secondAddress);
        }
        if (values.phoneNr) {
            formData.append("phoneNumber", values.phoneNr);
        }
        if (values.secondPhoneNr) {
            formData.append("secondPhoneNumber", values.secondPhoneNr);
        }
        if (values.email) {
            formData.append("email", values.email);
        }
        if (values.businessNr) {
            formData.append("businessNumber", values.businessNr);
        }
        if (values.bankAccountNr) {
            formData.append("bankAccountNumber", values.bankAccountNr);
        }
        if (values.bankName) {
            formData.append("bankAccount", values.bankName);
        }
        if (city?.label) {
            formData.append("city", city?.label);
        }
        if (country?.label) {
            formData.append("country", country.label || 'Kosovo');
        }
        if (kubitEnabled && entityTypeId) {
            formData.append("entityTypeId", String(entityTypeId));
        }
        if (kubitEnabled && phonePrefixId) {
            formData.append("phonePrefixId", String(phonePrefixId));
        }
        if (values.contactPerson) {
            formData.append("contactPerson", values.contactPerson);
        }

        if (values.parentName) {
            formData.append("parentName", values.parentName);
        }

        if (values.companyName) {
            formData.append("companyName", values.companyName);
        }

        // All validation passed and the payload is built — lock the operation for the
        // full duration of the (multi-step) save; cleared in `.finally` on each branch.
        // Set the ref synchronously (guards re-entry) and the state (drives the button).
        isSubmittingRef.current = true
        setIsSubmitting(true)

        if (clientId) {
            props.clientActions.editClient(clientId, formData).then(async () => {
                // Save projects
                const projectsForCreation = projectDetails.filter(p => !p.id)
                const projectsForEdit = projectDetails.filter(p => p.id)

                for (let index = 0; index < projectsForCreation.length; index++) {
                    const project = projectsForCreation[index]
                    let fd = new FormData()
                    fd.append("clientId", clientId)
                    fd.append("shipmentDestinationId[]", project?.shipmentDestinationId?.toString() || "1")
                    fd.append("withoutMeasurement[]", project?.withoutMeasurement ? "1" : "0")
                    fd.append("projectName[]", project?.projectName)
                    fd.append("measureDate[]", moment(project?.measureDate).format('YYYY-MM-DD') || '')
                    fd.append("projectLocation[]", project?.projectLocation || '')
                    fd.append("address[]", project?.address || '')
                    fd.append("projectComment[]", (project?.projectComment && project?.projectComment !== 'undefined') ? project?.projectComment : '')
                    project?.orders?.forEach(order => fd.append(`orders[${index}][]`, String(order?.value)))
                    project?.projectFiles?.forEach(file => { if (file?.file) fd.append(`projectFiles[${index}][]`, file.file) })
                    if (project?.measureAssignee?.value) fd.append("measureAssignee[]", String(project.measureAssignee.value))
                    const res = await props.clientActions.createProjects(fd)
                    if (res?.data?.unique?.name) {
                        toast.error(fmWithValues(
                            'contact.toast.projectAlreadyExists',
                            'A project named "{name}" already exists. Please try a different name.',
                            { name: res.data.unique.name }
                        ))
                        return
                    }
                }

                for (const project of projectsForEdit) {
                    let fd = new FormData()
                    fd.append("clientId", clientId)
                    fd.append("projectName", project?.projectName)
                    if (project?.shipmentDestinationId) fd.append("shipmentDestinationId", project.shipmentDestinationId.toString())
                    fd.append("withoutMeasurement", project?.withoutMeasurement ? "1" : "0")
                    fd.append("measureDate", project?.measureDate || '')
                    fd.append("projectLocation", project?.projectLocation || '')
                    fd.append("address", project?.address || '')
                    fd.append("projectComment", project?.projectComment || '')
                    project?.orders?.forEach(order => fd.append(`orders[]`, String(order?.value)))
                    project?.projectFiles?.forEach(file => { if (file?.file) fd.append(`projectFiles[]`, file.file) })
                    if (project?.measureAssignee?.value) fd.append("measureAssignee", String(project.measureAssignee.value))
                    await props.clientActions.editProject(project.id, fd)
                }

                toast.success(fm('contact.toast.clientUpdated', 'Client updated successfully.'))
                getModuleData()
            }).catch(err => toast.error(err.message))
                .finally(() => { isSubmittingRef.current = false; setIsSubmitting(false) })

        } else {
            props.clientActions.createClient(formData, letter_, fromDate, toDate).then((response) => {
                let formDataCreate = new FormData()
                projectDetails?.length !== 0 && projectDetails?.forEach((project, index) => {
                    formDataCreate.append("clientId", response.data?.data?.id);
                    formDataCreate.append("shipmentDestinationId[]", String(project?.shipmentDestinationId || "1"));
                    formDataCreate.append("withoutMeasurement[]", project?.withoutMeasurement ? "1" : "0");
                    formDataCreate.append("projectName[]", project?.projectName);
                    formDataCreate.append("measureDate[]", moment(project?.measureDate).format('YYYY-MM-DD'));
                    formDataCreate.append("projectLocation[]", project?.projectLocation);
                    formDataCreate.append("address[]", project?.address || '');
                    formDataCreate.append("projectComment[]", (project?.projectComment && project?.projectComment !== 'undefined') ? project?.projectComment : '');
                    if (project.orders?.length !== 0) {
                        project.orders?.forEach((order) => {
                            formDataCreate.append(`orders[${index}][]`, String(order?.value));
                        })
                    } else {
                        formDataCreate.append(`orders[${index}][]`, '');
                    }
                    if (project.projectFiles?.length !== 0) {
                        project.projectFiles?.forEach((file) => {
                            formDataCreate.append(`projectFiles[${index}][]`, file?.file);
                        })
                    } else {
                        formDataCreate.append(`projectFiles[${index}][]`, '');
                    }
                    if (project?.measureAssignee?.value) {
                        formDataCreate.append("measureAssignee[]", project?.measureAssignee?.value);
                    }
                })
                if (response?.data?.data) {
                    let payload = {
                        moduleId: 1,
                        clientId: response.data?.data?.id
                    }
                    setInitialValues({
                        nameAndSurname: response.data?.data?.firstnameAndLastname,
                        lastName: response.data?.data?.lastName,
                        phoneNr: response.data?.data?.phoneNumber,
                        secondPhoneNr: response.data?.data?.secondPhoneNumber,
                        email: response.data?.data?.email,
                        comment: response.data?.data?.commentAndDetails,
                        businessNr: response.data?.data?.businessNumber,
                        address: response.data?.data?.address,
                        secondAddress: response.data?.data?.secondAddress,
                        bankAccountNr: response.data?.data?.bankAccountNumber,
                        bankName: response.data?.data?.bankAccount,
                        contactPerson: response.data?.data?.contactPerson,
                        parentName: response.data?.data?.parentName,
                        companyName: response.data?.data?.companyName,
                        file: response.data?.data?.productPicture
                    })
                    setCity({
                        label: response.data?.data?.city
                    })
                    setCountry({
                        label: response.data?.data?.country
                    })
                    apiCaller('POST', `modules/create-client-for-next-module`, payload)
                    // Return the projects promise so the outer chain (and its `.finally`
                    // guard release) waits for the full create-client + create-projects flow.
                    return props.clientActions.createProjects(formDataCreate).then((res) => {
                        if (res?.data?.unique?.name) {
                            toast.error(fmWithValues(
                                'contact.toast.projectAlreadyExists',
                                'A project named "{name}" already exists. Please try a different name.',
                                { name: res.data.unique.name }
                            ))
                            return
                        }
                        toast.success(fm('contact.toast.clientCreated', 'Client created successfully.'))
                        history.push(`/dashboard/contact/create/${response.data?.data?.id}`)
                    })
                }
            }).catch(err => {
                console.log(err.message, JSON.stringify(err))
                toast.error(fm('contact.toast.somethingWentWrong', 'Something went wrong. Please try again.'))
            }).finally(() => { isSubmittingRef.current = false; setIsSubmitting(false) })
        }
        ;
    }

    function getTransferredDataFromModules(clientId) {
        setSearchedClient('')
        history.push(`/dashboard/contact/create/${clientId}`)
    }

    // Pre-compute localized destination labels used in several places.
    const destinationLabel = (id: number | string | undefined): string => {
        const n = Number(id);
        if (n === 1) return fm('contact.project.destinationDomestic', 'Domestic');
        if (n === 2) return fm('contact.project.destinationExport', 'Export');
        if (n === 3) return fm('contact.project.destinationStock', 'Inner stock');
        return '';
    };

    function createClientForm() {
        // The currently-selected phone prefix drives the local number's max length
        // (e.g. Kosovo +383 = 8). Business number length follows the Kosovo
        // convention: Person Fizik (KuBIT entity type 8) = 10, business subjects = 9.
        // KuBIT itself imposes no length (businessNumber is optional) — this is a
        // client-side nicety. Non-KuBIT companies get a generous defensive cap.
        const selectedPrefix = phonePrefixes.find((p: any) => p.value === phonePrefixId)
        // Business-number length/format by subject type: Person Fizik (8) = 10 digits;
        // Subjekt i Jashtem (4, foreign) = ANY format (EU/intl tax ids carry letters and
        // vary in length) up to 30; domestic subjects (1/2) = 9-digit Kosovo NUI.
        const businessNrMax = kubitEnabled ? (entityTypeId === 8 ? 10 : entityTypeId === 4 ? 30 : 9) : 16
        const businessNrRestrict: 'digits' | undefined = entityTypeId === 4 ? undefined : 'digits'
        const businessNrInputMode: 'text' | 'numeric' = entityTypeId === 4 ? 'text' : 'numeric'
        // KuBIT requires a business number for business subjects (1=me TVSH, 2=pa TVSH,
        // 4=i Jashtem); Person Fizik (8) may omit it. Drives the field's required marker.
        const businessNrRequired = kubitEnabled && entityTypeId !== null && [1, 2, 4].includes(entityTypeId)
        return (
            <div className="ccf-page">
                <FormikFormWrapper initialValues={initialValues} validationScheme={validationScheme()} onSubmit={saveClient}>
                    {/* Header */}
                    <div className="ccf-header">
                        <div className="ccf-header-info">
                            <h1 className="ccf-header-title">
                                {clientId ? `${initialValues.nameAndSurname} ${initialValues.lastName}` : fm('contact.form.newClientTitle', 'New client')}
                            </h1>
                            {createAt && <span className="ccf-header-date">{fm('contact.form.createdLabel', 'Created:')} {createAt}</span>}
                        </div>
                        {((!props.permissions.observer) || props.permissions.fullPrivileges) && (
                            <Button submit={true} isLoading={isSubmitting || props?.buttonLoader} isDisabled={isSubmitting || props?.buttonLoader} buttonType={EButtonType.PurpleButton} className="ccf-save-btn">
                                {clientId
                                    ? <FormattedMessage id="contact.form.editData" defaultMessage="Edit data" />
                                    : <FormattedMessage id="contact.form.saveData" defaultMessage="Save data" />}
                            </Button>
                        )}
                    </div>

                    {/* Two-panel layout */}
                    <div className="ccf-panels">
                        {/* LEFT: Client info */}
                        <div className="ccf-panel ccf-panel-client">
                            <div className="ccf-panel-header">
                                <span><FormattedMessage id="contact.form.clientInfoSection" defaultMessage="Client information" /></span>
                            </div>
                            <div className="ccf-panel-body">
                                <div className="ccf-fields">
                                    <MikaTextInput className="ccf-field-half" name="nameAndSurname" bordered labelKey={fm('contact.form.firstNameRequired', 'First name *')} />
                                    <MikaTextInput className="ccf-field-half" name="lastName" bordered labelKey={fm('contact.form.lastNameRequired', 'Last name *')} />
                                    {kubitEnabled ? (
                                        <div className="ccf-project-field ccf-field-half">
                                            <label><FormattedMessage id="contact.form.phoneRequired" defaultMessage="Phone *" /></label>
                                            <div className="ccf-phone-group">
                                                <Select
                                                    className="ccf-react-select ccf-phone-prefix"
                                                    classNamePrefix="react-select"
                                                    options={phonePrefixes}
                                                    value={phonePrefixes.find((p: any) => p.value === phonePrefixId) || null}
                                                    onChange={(val: any) => setPhonePrefixId(val?.value ?? null)}
                                                    placeholder={fm('contact.form.selectPrefix', 'Prefix...')}
                                                    formatOptionLabel={(option: any, meta: any) => (meta.context === 'value' ? option.prefix : option.label)}
                                                    noOptionsMessage={() => fm('contact.form.notFound', 'Not found')}
                                                />
                                                <MikaTextInput className="ccf-phone-number" name="phoneNr" bordered restrict="digits" inputMode="numeric" maxLength={selectedPrefix?.numberLength} />
                                            </div>
                                        </div>
                                    ) : (
                                        <MikaTextInput className="ccf-field-half" name="phoneNr" bordered labelKey={fm('contact.form.phoneRequired', 'Phone *')} restrict="phone" inputMode="tel" maxLength={50} />
                                    )}
                                    <MikaTextInput className="ccf-field-half" name="email" bordered labelKey={fm('contact.form.email', 'Email')} />

                                    <div className={`ccf-project-field ccf-field-half ${showRequiredMessage && !country?.label ? 'ccf-field-error' : ''}`}>
                                        <label><FormattedMessage id="contact.form.country" defaultMessage="Country" /> <span className="ccf-required">*</span></label>
                                        <Select
                                            className="ccf-react-select"
                                            classNamePrefix="react-select"
                                            options={countries}
                                            value={country?.label ? country : null}
                                            onChange={(val) => setCountry(val || {})}
                                            placeholder={fm('contact.form.selectCountry', 'Select country...')}
                                            isClearable
                                            noOptionsMessage={() => fm('contact.form.notFound', 'Not found')}
                                        />
                                        {showRequiredMessage && !country?.label && <span className="ccf-inline-error"><FormattedMessage id="contact.form.fieldRequired" defaultMessage="This field is required." /></span>}
                                    </div>
                                    <div className={`ccf-project-field ccf-field-half ${showRequiredMessage && !city?.label ? 'ccf-field-error' : ''}`}>
                                        <label><FormattedMessage id="contact.form.city" defaultMessage="City" /> <span className="ccf-required">*</span></label>
                                        <CreatableSelect
                                            className="ccf-react-select"
                                            classNamePrefix="react-select"
                                            options={cities}
                                            value={city?.label ? city : null}
                                            onChange={(val) => setCity(val || {})}
                                            onCreateOption={(inputValue) => setCity({ label: inputValue, value: inputValue })}
                                            placeholder={fm('contact.form.selectCity', 'Select city...')}
                                            isClearable
                                            formatCreateLabel={(inputValue) => `${inputValue}`}
                                            noOptionsMessage={() => fm('contact.form.selectCountryFirst', 'Select country first')}
                                        />
                                        {showRequiredMessage && !city?.label && <span className="ccf-inline-error"><FormattedMessage id="contact.form.fieldRequired" defaultMessage="This field is required." /></span>}
                                    </div>

                                    {kubitEnabled && (
                                        <div className={`ccf-project-field ccf-field-half ${showRequiredMessage && !entityTypeId ? 'ccf-field-error' : ''}`}>
                                            <label><FormattedMessage id="contact.form.entityType" defaultMessage="Subject type" /> <span className="ccf-required">*</span></label>
                                            <Select
                                                className="ccf-react-select"
                                                classNamePrefix="react-select"
                                                options={entityTypes}
                                                value={entityTypes.find((t: any) => t.value === entityTypeId) || null}
                                                onChange={(val: any) => setEntityTypeId(val?.value ?? null)}
                                                placeholder={fm('contact.form.selectEntityType', 'Select subject type...')}
                                                noOptionsMessage={() => fm('contact.form.notFound', 'Not found')}
                                            />
                                            {showRequiredMessage && !entityTypeId && <span className="ccf-inline-error"><FormattedMessage id="contact.form.fieldRequired" defaultMessage="This field is required." /></span>}
                                        </div>
                                    )}

                                    {/* KuBIT: business number lives here (driven by the subject type), NOT behind
                                        the "Company?" toggle — so a me-TVSH client can always enter the number KuBIT
                                        requires. Required for types 1/2/4; optional for Person Fizik (8). */}
                                    {kubitEnabled && (
                                        <MikaTextInput className="ccf-field-half" name="businessNr" bordered restrict={businessNrRestrict} inputMode={businessNrInputMode} maxLength={businessNrMax}
                                            labelKey={fm('contact.form.businessNr', 'Business number') + (businessNrRequired ? ' *' : '')} />
                                    )}

                                    <MikaTextInput className="ccf-field-half" name="address" bordered labelKey={fm('contact.form.address', 'Address')} />
                                    <MikaTextInput className="ccf-field-half" name="contactPerson" bordered labelKey={fm('contact.form.contactPerson', 'Contact person')} />
                                </div>

                                <div className="ccf-company-toggle" onClick={() => setIsCompany(!isCompany)}>
                                    <div className={`ccf-checkbox ${isCompany ? 'ccf-checkbox-checked' : ''}`}>
                                        {isCompany && <FontAwesome name="check" />}
                                    </div>
                                    <span><FormattedMessage id="contact.form.isCompany" defaultMessage="Company?" /></span>
                                </div>

                                {isCompany && (
                                    <div className="ccf-fields ccf-company-fields">
                                        <MikaTextInput className="ccf-field-half" name="companyName" bordered labelKey={fm('contact.form.companyName', 'Company name')} maxLength={100} />
                                        {/* Non-KuBIT keeps the business number here under "Company?"; KuBIT renders it
                                            above, driven by subject type (avoids a duplicate businessNr field). */}
                                        {!kubitEnabled && <MikaTextInput className="ccf-field-half" name="businessNr" bordered labelKey={fm('contact.form.businessNr', 'Business number')} restrict="digits" inputMode="numeric" maxLength={businessNrMax} />}
                                        <MikaTextInput className="ccf-field-half" name="secondPhoneNr" bordered labelKey={fm('contact.form.secondPhone', 'Secondary phone')} restrict="phone" inputMode="tel" maxLength={50} />
                                        <MikaTextInput className="ccf-field-half" name="secondAddress" bordered labelKey={fm('contact.form.secondAddress', 'Secondary address')} maxLength={150} />
                                        <MikaTextInput className="ccf-field-half" name="bankName" bordered labelKey={fm('contact.form.bankName', 'Bank name')} maxLength={100} />
                                        <MikaTextInput className="ccf-field-half" name="bankAccountNr" bordered labelKey={fm('contact.form.bankAccountNr', 'Bank account number')} maxLength={34} />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* RIGHT: Projects */}
                        <div className="ccf-panel ccf-panel-projects">
                            <div className="ccf-panel-header">
                                <span>
                                    <FormattedMessage
                                        id="contact.form.projects.title"
                                        defaultMessage="Projects ({count})"
                                        values={{ count: projectDetails?.length || 0 }}
                                    />
                                </span>
                                <button type="button" className="ccf-add-project-btn" onClick={addNewProject}>
                                    <FontAwesome name="plus" /> <FormattedMessage id="contact.form.projects.addProject" defaultMessage="Add project" />
                                </button>
                            </div>
                            <div className="ccf-panel-body ccf-projects-body">
                                {projectDetails.map((project, index) => (
                                    <div className={`ccf-project-card ${expandedProject === index ? 'ccf-project-expanded' : ''}`} key={project.id || index}>
                                        {/* Summary bar (always visible) */}
                                        <div className="ccf-project-summary" onClick={() => setExpandedProject(expandedProject === index ? -1 : index)}>
                                            <FontAwesome name="folder" className="ccf-project-icon" />
                                            <span className="ccf-project-name">{project.projectName || fm('contact.form.projects.newProjectTitle', 'New project')}</span>
                                            {project.shipmentDestinationId && (
                                                <span className={`ccf-project-badge ${project.shipmentDestinationId === 1 ? 'badge-vendore' : project.shipmentDestinationId === 2 ? 'badge-export' : 'badge-stok'}`}>
                                                    {destinationLabel(project.shipmentDestinationId)}
                                                </span>
                                            )}
                                            {project.measureDate && <span className="ccf-project-date">{project.measureDate}</span>}
                                            <FontAwesome name={expandedProject === index ? 'chevron-up' : 'chevron-down'} className="ccf-project-chevron" />
                                        </div>

                                        {/* Expanded body */}
                                        {expandedProject === index && (
                                            <div className="ccf-project-body">
                                                <div className={`ccf-project-field ${showRequiredMessage && !project.projectName ? 'ccf-field-error' : ''}`}>
                                                    <label><FormattedMessage id="contact.project.name" defaultMessage="Project name" /> <span className="ccf-required">*</span></label>
                                                    <input value={project.projectName || ''} onChange={(e) => changeProjectDetails('projectName', e.target.value, index)} placeholder={fm('contact.project.namePlaceholder', 'Project name')} />
                                                    {showRequiredMessage && !project.projectName && <span className="ccf-inline-error"><FormattedMessage id="contact.toast.projectNameRequired" defaultMessage="Project name is required." /></span>}
                                                </div>

                                                <div className="ccf-project-field-row">
                                                    <div className={`ccf-project-field ${showRequiredMessage && !project.id && !project.shipmentDestinationId ? 'ccf-field-error' : ''}`}>
                                                        <label><FormattedMessage id="contact.project.destinationLabel" defaultMessage="Destination" /> <span className="ccf-required">*</span></label>
                                                        <Select
                                                            className="ccf-react-select"
                                                            classNamePrefix="react-select"
                                                            options={[
                                                                {value: 1, label: fm('contact.project.destinationDomestic', 'Domestic')},
                                                                {value: 2, label: fm('contact.project.destinationExport', 'Export')},
                                                                {value: 3, label: fm('contact.project.destinationStock', 'Inner stock')}
                                                            ]}
                                                            value={project.shipmentDestinationId ? {value: project.shipmentDestinationId, label: destinationLabel(project.shipmentDestinationId)} : null}
                                                            onChange={(val) => changeProjectDetails('shipmentDestinationId', val?.value, index)}
                                                            placeholder={fm('contact.project.select', 'Select...')}
                                                            isSearchable={false}
                                                        />
                                                        {showRequiredMessage && !project.id && !project.shipmentDestinationId && <span className="ccf-inline-error"><FormattedMessage id="contact.toast.projectDestinationRequired" defaultMessage="Project destination is required." /></span>}
                                                    </div>
                                                    <div className="ccf-project-field">
                                                        <label><FormattedMessage id="contact.project.projectType" defaultMessage="Project type" /></label>
                                                        <div className="ccf-measurement-toggle">
                                                            <span><FormattedMessage id="contact.project.withoutMeasurement" defaultMessage="Without measurement" /></span>
                                                            <div className="ccf-toggle-btns">
                                                                <button type="button" className={!project.withoutMeasurement ? 'active' : ''} onClick={() => changeProjectDetails('withoutMeasurement', 0, index)}><FormattedMessage id="contact.project.no" defaultMessage="No" /></button>
                                                                <button type="button" className={project.withoutMeasurement ? 'active' : ''} onClick={() => changeProjectDetails('withoutMeasurement', 1, index)}><FormattedMessage id="contact.project.yes" defaultMessage="Yes" /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="ccf-project-field-row">
                                                    <div className="ccf-project-field">
                                                        <label><FormattedMessage id="contact.project.addressLabel" defaultMessage="Address" /></label>
                                                        <input value={project.address || ''} onChange={(e) => changeProjectDetails('address', e.target.value, index)} placeholder={fm('contact.project.addressPlaceholder', 'Project address...')} />
                                                    </div>
                                                    <div className="ccf-project-field">
                                                        <label><FormattedMessage id="contact.project.measurementDate" defaultMessage="Measurement date" /></label>
                                                        <input type="date" value={project.measureDate || ''} onChange={(e) => changeProjectDetails('measureDate', e.target.value, index)} />
                                                    </div>
                                                </div>

                                                <div className="ccf-project-field-row">
                                                    <div className="ccf-project-field">
                                                        <label><FormattedMessage id="contact.project.measurementOfficer" defaultMessage="Measurement officer" /></label>
                                                        <Select
                                                            className="ccf-react-select"
                                                            classNamePrefix="react-select"
                                                            options={props.measureUsers}
                                                            value={project.measureAssignee?.label ? project.measureAssignee : null}
                                                            onChange={(val) => changeProjectDetails('measureAssignee', val || {}, index)}
                                                            placeholder={fm('contact.project.select', 'Select...')}
                                                            isClearable
                                                            noOptionsMessage={() => fm('contact.form.notFound', 'Not found')}
                                                        />
                                                    </div>
                                                    <div className="ccf-project-field">
                                                        <label><FormattedMessage id="contact.project.articles" defaultMessage="Articles" /></label>
                                                        <Select id={`order-${index}`} name="order" options={props.articles} closeMenuOnSelect={false} className="ccf-react-select" classNamePrefix="react-select" isMulti value={project.orders || []} onChange={(value) => changeProjectDetails('orders', value, index)} placeholder={fm('contact.project.selectArticles', 'Select articles...')} />
                                                    </div>
                                                </div>

                                                <div className="ccf-project-field">
                                                    <label><FormattedMessage id="contact.project.gpsCoordinates" defaultMessage="GPS coordinates" /></label>
                                                    <div className="ccf-gps-row">
                                                        <input
                                                            value={project.projectLocation && project.projectLocation !== 'undefined' ? project.projectLocation : ''}
                                                            onChange={(e) => changeProjectDetails('projectLocation', e.target.value, index)}
                                                            placeholder={fm('contact.project.gpsPlaceholder', '42.6629, 21.1655')}
                                                        />
                                                        <button type="button" className="ccf-gps-btn" onClick={() => getCurrentPosition(index)}>
                                                            <FontAwesome name="map-marker" /> GPS
                                                        </button>
                                                    </div>
                                                    {project.projectLocation && project.projectLocation !== 'undefined' && (
                                                        <a href={`https://www.google.com/maps/?q=${project.projectLocation}`} target="_blank" rel="noopener noreferrer" className="ccf-gps-link">
                                                            <FormattedMessage id="contact.project.viewOnGoogleMaps" defaultMessage="View on Google Maps" />
                                                        </a>
                                                    )}
                                                </div>

                                                <div className="ccf-project-field">
                                                    <label><FormattedMessage id="contact.project.commentLabel" defaultMessage="Comment" /></label>
                                                    <textarea value={project.projectComment || ''} onChange={(e) => changeProjectDetails('projectComment', e.target.value, index)} placeholder={fm('contact.project.commentPlaceholder', 'Project comment...')} />
                                                </div>

                                                {(() => {
                                                    const savedFiles = project?.projectFiles?.filter(f => f.id || f.fileUrl) || []
                                                    const savedFileIds = savedFiles.filter(f => f.id).map(f => f.id)
                                                    const selected = selectedFiles[index] || []
                                                    const allSelected = savedFileIds.length > 0 && savedFileIds.every(id => selected.includes(id))
                                                    return (
                                                        <div className="ccf-files-section">
                                                            <MikaFileManager
                                                                loading={filesLoading}
                                                                files={savedFiles.filter((f: any) => f.id).map((f: any) => ({ id: f.id, name: f.fileName, url: f.fileUrl }))}
                                                                uploadSlots={[
                                                                    { key: 'projectFiles', label: fm('contact.project.addDocuments', 'Add documents'), icon: 'files', multiple: true },
                                                                ]}
                                                                onUpload={(key, files) => {
                                                                    const mapped = files.map(f => ({ file: f, fileName: f.name }));
                                                                    changeProjectDetails('projectFiles', [...(project?.projectFiles?.filter((f: any) => f.id) || []), ...mapped], index);
                                                                }}
                                                                onDelete={(fileId) => removeProjectFile(fileId)}
                                                                onBulkDelete={(ids) => {
                                                                    setConfirmAction({
                                                                        message: fmWithValues(
                                                                            'contact.project.confirmDeleteBulkFiles',
                                                                            'Are you sure you want to delete {count, plural, one {# file} other {# files}}?',
                                                                            { count: ids.length }
                                                                        ),
                                                                        onConfirm: async () => {
                                                                            setConfirmAction(null);
                                                                            setFilesLoading(true);
                                                                            try {
                                                                                for (const id of ids) {
                                                                                    await props.generalActions?.removeFile('project', id);
                                                                                }
                                                                                await getModuleData();
                                                                            } finally {
                                                                                setFilesLoading(false);
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    )
                                                })()}

                                                {(props.permissions?.superAdmin || props.permissions?.fullPrivileges) && (
                                                    <button type="button" className="ccf-delete-project-btn" onClick={() => deleteProject(project.id, index)} disabled={deletePreviewLoading}>
                                                        <FontAwesome name="trash" /> <FormattedMessage id="contact.form.projects.deleteProject" defaultMessage="Delete project" />
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}

                                {projectDetails.length === 0 && (
                                    <div className="ccf-no-projects">
                                        <FontAwesome name="folder-open" className="ccf-empty-icon" />
                                        <p><FormattedMessage id="contact.form.projects.emptyState" defaultMessage="No projects added yet" /></p>
                                        <button type="button" className="ccf-add-first-btn" onClick={addNewProject}>
                                            <FontAwesome name="plus" /> <FormattedMessage id="contact.form.projects.addFirstProject" defaultMessage="Add the first project" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </FormikFormWrapper>

                {confirmAction && (
                    <div className="ccf-confirm-overlay" onClick={() => setConfirmAction(null)}>
                        <div className="ccf-confirm-modal" onClick={(e) => e.stopPropagation()}>
                            <p className="ccf-confirm-message">{confirmAction.message}</p>
                            <div className="ccf-confirm-actions">
                                <button type="button" className="ccf-confirm-cancel" onClick={() => setConfirmAction(null)}>
                                    <FormattedMessage id="contact.project.cancel" defaultMessage="Cancel" />
                                </button>
                                <button type="button" className="ccf-confirm-yes" onClick={confirmAction.onConfirm}>
                                    <FormattedMessage id="contact.project.confirm" defaultMessage="Yes, delete" />
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="wrapper">
            {props.loading ? <Spinner /> : createClientForm()}
        </div>
    )
}

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        client: state.client,
        user: state.user,
        countries: state.app.countriesFields,
        cities: state.app.citiesFields,

    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
        clientActions: bindActionCreators(clientActions as any, dispatch),
        generalActions: bindActionCreators(generalActions as any, dispatch),
        projectDeletionActions: bindActionCreators(projectDeletionActions as any, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreateContactForm as any)))
